module.exports = __webpack_public_path__ + "static/media/search.d554ff05.gif";